import React from "react";
import { Button, List } from "arag-ui-lib"
import { amountColumnsDisplayDataPerStage } from "../../helpers/functions";
import StagedStep4 from "./WizardSteps/stagedStep4";
import CONTENT_STRINGS from "../../helpers/contentStrings";
import { LOCALE_UK, QUATERNARY, RIGHT } from "../../helpers/constants";

 const StagedPremiumSettingsCombinationTable = (props) => {
    const {
        allStagedPremiums,
        push,
    } = props;
    return (
        <div className="row">
            <div className="col-sm-12 ">
                <List
                    id={"sortable"}
                    variant={"toggle"}
                    items={
                        allStagedPremiums.map((item, index) => {
                            const toggleHeading = new Date(item.validFrom).toLocaleDateString(LOCALE_UK) + (item.validUntil ? (' - ' + new Date(item.validUntil).toLocaleDateString(LOCALE_UK)) : '');
                            return {
                                id: item.id,
                                className: `refSettingsListItem`,
                                toggleHeading: toggleHeading,
                                linkItemTestId: `staged-premium-setting-${index}-item`,
                                content: (
                                    <>
                                        <div className='btn-wrapper-forForms'>
                                            <Button 
                                                variant={QUATERNARY}
                                                arrowDirection={RIGHT}
                                                onClick={() => { push('premium-settings/edit-staged-premium-settings/' + item.id) }}
                                                label={CONTENT_STRINGS.EDIT}
                                                buttonTestId={`staged-premium-setting-${index}-edit`}
                                            />
                                        </div>
                                        <form className="form-horizontal">
                                            <StagedStep4
                                                amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
                                                isApplicationPremium={false}
                                                stagedPremiumData={item}
                                                stagesSubSettings={item.stagedPremiumSubSettings}
                                                currentStep={4}
                                            />
                                        </form>
                                    </>
                                )
                            };
                        })
                    }
                />
            </div>
        </div>
    )
}

export default StagedPremiumSettingsCombinationTable;